import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'activeCode',
            component: () => import('../views/activeCode/index.vue')
        },
        {
            path: '/activeInstructions',
            name: 'activeInstructions',
            component: () => import('../views/activeInstructions/index.vue')
        },
        {
            path: '/cashier',
            name: 'cashier',
            component: () => import('../views/cashier/index.vue')
        },
        {
            path: '/game/notice/:id/:uid',
            name: 'noticeDetail',
            component: () => import('../views/notice/index.vue')
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})
